import React from 'react';
import { Section } from './ui/Section';
export function Testimonials({
  limit = 3,
  className = ''
}: {
  limit?: number;
  className?: string;
}) {
  const testimonials = [{
    initials: 'CR',
    quote: 'La primera semana ya tenía mi tarifa calculada y un mensaje de prospección que funcionó. Conseguí un cliente nuevo en 9 días.',
    author: 'Carlos R., Madrid · Diseñador Freelance'
  }, {
    initials: 'AS',
    quote: 'Por fin sé cuánto cobrar sin sentirme un fraude. La Calculadora de Supervivencia me cambió la cabeza completamente.',
    author: 'Andrea S., Barcelona · Copywriter'
  }, {
    initials: 'JM',
    quote: 'Llevaba 2 años con un cliente que me cambiaba todo sin pagar más. Con el contrato del Tomo 4 eso se acabó para siempre.',
    author: 'Javier M., Valencia · Consultor Digital'
  }];
  const displayTestimonials = limit ? testimonials.slice(0, limit) : testimonials;
  return <Section className={className} data-id="element-195">
      <div className={`grid gap-6 ${limit === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'}`} data-id="element-196">
        {displayTestimonials.map((t, i) => <div key={i} className="bg-brand-card border border-neutral-800 rounded-2xl p-6 flex flex-col hover:border-neutral-700 transition-colors" data-id="element-197">
            <div className="flex items-center gap-3 mb-4" data-id="element-198">
              <div className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center font-bold text-neutral-300" data-id="element-199">
                {t.initials}
              </div>
              <div className="flex text-brand-accent text-sm" data-id="element-200">⭐⭐⭐⭐⭐</div>
            </div>
            <p className="text-neutral-300 italic mb-6 flex-grow" data-id="element-201">
              "{t.quote}"
            </p>
            <p className="text-sm text-neutral-500 font-medium" data-id="element-202">— {t.author}</p>
          </div>)}
      </div>
    </Section>;
}